export default __webpack_public_path__ + "static/media/post.18c27faa.svg";